module.exports = __webpack_public_path__ + "img/04招聘.cf127704.jpg";